"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_pdf_1 = require("react-pdf");
const __1 = require("..");
react_pdf_1.pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${react_pdf_1.pdfjs.version}/legacy/build/pdf.worker.min.js`;
const PdfPreview = ({ src }) => {
    const containerRef = (0, react_1.useRef)(null);
    const [numPages, setNumPages] = (0, react_1.useState)(0);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const pages = [];
    for (let i = 1; i <= numPages; i++) {
        pages.push(react_1.default.createElement(react_pdf_1.Page, { pageNumber: i, width: containerRef.current?.offsetWidth }));
    }
    return (react_1.default.createElement(__1.Box, { width: "100%", ref: containerRef },
        react_1.default.createElement(react_pdf_1.Document, { file: src, onLoadSuccess: onDocumentLoadSuccess }, pages)));
};
exports.default = PdfPreview;
